import axios from 'axios';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { reduxForm } from 'redux-form';
import moment from 'moment';
var _ = require('lodash');

function HistoryRows(data) {
  const history_inner_rows = _.map(data, (i, key) => 
    <div key={key} className="card" style={{ backgroundColor: 'white' }} >
      <div className="card-body">
        {i.content}
        <span className="display-block text-muted">
          {moment(i.created_date).format("DD-MM-YYYY hh:mm:ss")}
        </span>
        <br/>
        <span className="display-block text-muted">
          {i.user && <p>{i.user.full_name}</p>}
          {i.support && <p>{i.support.full_name}</p>}
          {i.sale && <p>{i.sale.full_name}</p>}
        </span>
      </div>
    </div>
  )
  return history_inner_rows;
}

const mapState = state => ({
   
});

const mapDispatch = (dispatch) => ({

});

class HistoryPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      result_data: [],
      alert_label: null
    }
  }

  // Lịch sử tương tác đơn hàng.
  invoiceHistory = (invoice_id) => {
    const self = this;
    return axios({
      method: 'get',
      url: window.api_url + '/admin/api/invoice/history/' + invoice_id,
      withCredentials: true
    }).then(function (response) {
      if (response.data.data) {
        self.setState({
          result_data: response.data.data,
        })
      }
    });
  }
  // Lịch sử tương tác dịch vụ
  serviceHistory = (user_product_id) => {
    const self = this;
    return axios({
      method: 'get',
      url: window.api_url + '/admin/api/service/history/' + user_product_id,
      withCredentials: true
    }).then(function (response) {
      if (response.data.data) {
        self.setState({
          result_data: response.data.data,
        })
      }
    });
  }

  reload = () => {
    const { user_product_id, invoice_id } = this.props.match.params;
    if(user_product_id) { 
      this.serviceHistory(user_product_id);   
    }
    if(invoice_id) {
      this.invoiceHistory(invoice_id);
    }
  }
  

  componentDidMount() {
    this.reload();
  }

  render() {
    const { result_data } = this.state;
    const { title } = this.props;
    return (
      <React.Fragment>
        <div className="page-header">
          <h4>
            <i className=" icon-paragraph-justify2 position-left"></i>
            <span className="text-semibold">{title}</span>
          </h4>
        </div>
        {result_data && result_data.length > 0  && HistoryRows(result_data)}
        {result_data.length == 0 && <div className="card card-body">
          <h5>Chưa có lịch sử tương tác.</h5> 
        </div>}
      </React.Fragment>
    )
  }
}


const HistoryPageWrapper = reduxForm({
  form: 'ticketForm',
  destroyOnUnmount: true,
  enableReinitialize: true
  // validate
})(HistoryPage);

export default connect(mapState, mapDispatch)(withRouter(HistoryPageWrapper));